import React from 'react';
import {Link} from 'react-router-dom';
import './styles.css';
import {Navbar, Container, Nav} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';


/* eslint "require-jsdoc": [2, {
    "require": {
        "FunctionDeclaration": true,
        "MethodDefinition": false,
        "ClassDeclaration": false
    }
}]*/
/**
* @return {html} Navbar.
  */
function NavBar() {
  return (
    <Navbar className='colorNav' variant="light" expand="lg">
      <Container fluid>
        <Navbar.Toggle aria-controls="navbar-dark-example" />
        <h3 className='companyName'>Burger Lab</h3>
        <Navbar.Collapse id="navbar-dark-example">
          <Nav className={'navContent'}>
            <div className='navLink'>
              <Link className="nav-link" to="/home"
                style={{color: '#FFF'}}> Home</Link>
              <Link className="nav-link" to="/profile"
                style={{color: '#FFF'}}>Profile</Link>
              <Link className="nav-link" to="/redeem"
                style={{color: '#FFF'}}>Redeem</Link>
              <Link className="nav-link" to="/receipt"
                style={{color: '#FFF'}}>Receipt</Link>
              <Link className="nav-link" to="/"
                style={{color: '#FFF'}} >Logout</Link>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
export default NavBar;
